import React from 'react'
import PropTypes from 'prop-types'
import {
  getCategories,
  getLastSelectedCategory
} from '../../../../redux/selectors/planCategories'
import { getCategoryRelationships } from '../../../../redux/selectors/planCategoryPlanSubcategories'
import {
  removeCategoryFilter,
  addSubcategoryFilter,
  removeSubcategoryFilter,
  setDifficultyFilter,
  setIntensityFilter,
  clearDifficultyFilter,
  clearIntensityFilter,
  applyCategoryFilter,
  setProductOrder,
  removeSeriesFilter,
  clearAllSeriesFilters
} from '../../../../redux/actions/products/filters'
import { loadProductsPage } from '../../../../redux/actions/products/products'
import { setSelectedCategorySlug } from '../../../../redux/actions/planCategories'
import { connect } from 'react-redux'

import {
  getCategoryObj,
  getSubcategoryObj
} from '../browseBy/exploreFilterHelpers'

import SelectedFiltersDisplay from '../../../filtersRow/SelectedFiltersDisplay'
import ClassFinderNewSortAndClear from '../../classFinder/ClassFinderNewSortAndClear'

class SeriesFinderNewFilteredList extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      categoryDropdownOpen: false,
      groupDropdownOpen: false,
      activeCategory: '',
      toBeOpenDropdown: '',
      filterModal: false
    }

    this.buildFilteredLabels = this.buildFilteredLabels.bind(this)
    this.allSelected = this.allSelected.bind(this)
    this.removeFilter = this.removeFilter.bind(this)
    this.clearAllFilters = this.clearAllFilters.bind(this)
  }

  allSelected(category) {
    const subcategories = this.props.filters.categories[category.slug]
    return subcategories === 'all'
  }

  buildFilteredLabels() {
    let filteredItems = {}
    const filteredCategories = this.props.filters.categories

    for (const categorySlug in filteredCategories) {
      const subcategorySlugs = filteredCategories[categorySlug]
      const category = getCategoryObj(this.props.categories, categorySlug)
      if (category && this.allSelected(category)) {
        let text = category.title
        const categorySubcategories = category.subcategories || []
        // if (categorySubcategories.length > 0) {
        text = `All ${text}`
        // }
        filteredItems[category.slug] = [
          {
            text,
            meta: category.slug
          }
        ]
      } else if (Array.isArray(subcategorySlugs)) {
        filteredItems[categorySlug] = subcategorySlugs.map(
          (subcategorySlug) => {
            const subcategory = getSubcategoryObj(
              category.subcategories,
              subcategorySlug
            )
            let text = ''
            const numberOfParentCategories = this.props.categoryRelationships
              .filter((categorySubcategory) => {
                const subcategorySlug =
                  categorySubcategory.toPlanSubcategoryId.split('_')[1]
                const subcategoryToCompareSlug = subcategory.slug.split('_')[1]
                return subcategorySlug === subcategoryToCompareSlug
              })
              .count()
            if (numberOfParentCategories > 1) {
              text = `${category.title}:`
            }
            return {
              text: text + subcategory.title,
              meta: subcategory.slug
            }
          }
        )
      }
    }
    if (this.props.filters.difficulties) {
      const difficlutyFilter = this.props.filters.difficulties.map((item) => {
        return {
          text: `${item}`,
          meta: item
        }
      })
      filteredItems['difficulties'] = difficlutyFilter
    }
    if (this.props.filters.intensities) {
      const intensityFilter = this.props.filters.intensities.map((item) => {
        return {
          text: `Level ${item}`,
          meta: item
        }
      })
      filteredItems['intensities'] = intensityFilter
    }

    if (this.props.filters.instructors) {
      const instructorFilter = this.props.filters.instructors.map((item) => {
        return {
          text: `${item?.user?.firstName} ${item?.user?.lastName}`,
          meta: item.slug
        }
      })
      filteredItems['instructors'] = instructorFilter
    }
    if (this.props.filters['focus_area']) {
      const focusAreaFilter = this.props.filters['focus_area'].map((item) => {
        return {
          text: item,
          meta: item
        }
      })
      filteredItems['focus_area'] = focusAreaFilter
    }
    if (this.props.filters.equipment) {
      const equipmentFilter = this.props.filters.equipment.map((item) => {
        return {
          text: item,
          meta: item
        }
      })
      filteredItems['equipment'] = equipmentFilter
    }

    return filteredItems
  }

  removeFilter(parentCategorySlug, slug) {
    if (
      [
        'instructors',
        'equipment',
        'focus_area',
        'difficulties',
        'intensities'
      ].includes(parentCategorySlug)
    ) {
      this.props.removeSeriesFilter(parentCategorySlug, slug)
    } else {
      const isACategory = Object.keys(this.props.filters.categories).includes(
        slug
      )

      if (isACategory) {
        this.props.removeCategoryFilter(slug)
      } else {
        this.props.removeSubcategoryFilter(parentCategorySlug, slug)
      }
    }

    this.props.loadProductPage(true, this.props.onAfterProductLoad)
  }

  clearAllFilters() {
    this.props.clearAllSeriesFilters()
    this.props.loadProductPage(true, this.props.onAfterProductLoad)
  }

  render() {
    const filteredLabels = this.buildFilteredLabels()

    return (
      <>
        <SelectedFiltersDisplay
          filteredItemLabels={filteredLabels}
          onLabelClick={this.removeFilter}
        />
        <ClassFinderNewSortAndClear
          sortableFields={['rank', 'az', 'date']}
          filteredItemLabels={filteredLabels}
          onClearAll={this.clearAllFilters}
          totalProducts={this.props.totalProducts}
          order={this.props.order === 'relevance' ? 'rank' : this.props.order}
          onSort={(order) => {
            this.props.setProductOrder(order)
            this.props.loadProductPage(true, this.props.onAfterProductLoad)
          }}
          contentLabel='Programs'
        />
      </>
    )
  }
}

SeriesFinderNewFilteredList.propTypes = {
  addSubcategoryFilter: PropTypes.func,
  categoryRelationships: PropTypes.object,
  clearDifficultyFilter: PropTypes.func,
  setDifficultyFilter: PropTypes.func,
  setIntensityFilter: PropTypes.func,
  clearIntensityFilter: PropTypes.func,
  removeCategoryFilter: PropTypes.func,
  removeSubcategoryFilter: PropTypes.func,
  categories: PropTypes.array,
  setLastSelectedCategory: PropTypes.func,
  filters: PropTypes.object,
  presentedCategory: PropTypes.object,
  group: PropTypes.string,
  layout: PropTypes.string,
  onSort: PropTypes.func,
  order: PropTypes.string,
  applyCategoryFilter: PropTypes.func,
  selectLayout: PropTypes.func,
  totalProducts: PropTypes.number,
  loadProductPage: PropTypes.func,
  onAfterProductLoad: PropTypes.func,
  setProductOrder: PropTypes.func
}

const mapStateToProps = (state) => {
  return {
    categories: getCategories(state),
    categoryRelationships: getCategoryRelationships(state),
    presentedCategory: getLastSelectedCategory(state)
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setLastSelectedCategory: (newCategorySlug) => {
      dispatch(setSelectedCategorySlug(newCategorySlug))
    },
    addSubcategoryFilter: (parentCategory, filter) => {
      dispatch(addSubcategoryFilter(parentCategory, filter))
    },
    removeCategoryFilter: (filterSlug) => {
      dispatch(removeCategoryFilter(filterSlug))
    },
    removeSubcategoryFilter: (
      parentCategory,
      filterSlug,
      clearParent = true
    ) => {
      dispatch(removeSubcategoryFilter(parentCategory, filterSlug, clearParent))
    },
    setDifficultyFilter: (difficulty) => {
      dispatch(setDifficultyFilter(difficulty))
    },
    clearDifficultyFilter: () => {
      dispatch(clearDifficultyFilter())
    },
    setIntensityFilter: (intensity) => {
      dispatch(setIntensityFilter(intensity))
    },
    clearIntensityFilter: () => {
      dispatch(clearIntensityFilter())
    },
    loadProductPage: (reloadAll, callback) => {
      dispatch(loadProductsPage(reloadAll, callback))
    },
    applyCategoryFilter: (category) => {
      dispatch(applyCategoryFilter(category))
    },
    setProductOrder: (order) => {
      dispatch(setProductOrder(order))
    },
    removeSeriesFilter: (parentCategory, filter) => {
      dispatch(removeSeriesFilter(parentCategory, filter))
    },
    clearAllSeriesFilters: () => {
      dispatch(clearAllSeriesFilters())
    }
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SeriesFinderNewFilteredList)
